import { LayersControl, TileLayer } from "react-leaflet";

const isLight = () => typeof document !== "undefined" && document.documentElement.classList.contains("light");

// All free, no-API-key OpenStreetMap-based base layers. Users switch via the layers control (top-right).
export default function MapBaseLayers() {
  const light = isLight();
  return (
    <LayersControl position="topright">
      <LayersControl.BaseLayer checked={!light} name="Dark">
        <TileLayer url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" attribution="&copy; OpenStreetMap &copy; CARTO" maxZoom={20} />
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer checked={light} name="Light">
        <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" attribution="&copy; OpenStreetMap &copy; CARTO" maxZoom={20} />
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name="OSM Standard">
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap contributors" maxZoom={19} />
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name="Satellite">
        <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" attribution="&copy; Esri, Maxar, Earthstar Geographics" maxZoom={19} />
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name="Terrain">
        <TileLayer url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png" attribution="&copy; OpenTopoMap (CC-BY-SA)" maxZoom={17} />
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name="Humanitarian">
        <TileLayer url="https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png" attribution="&copy; OpenStreetMap, HOT" maxZoom={19} />
      </LayersControl.BaseLayer>
    </LayersControl>
  );
}
